import { LoginCredentials } from "@/domain/entities";
import { AuthRepository, LoginResult } from "../../domain/repositories";
import { AuthDataSource } from "../datasources/auth";

export class AuthRepoImpl implements AuthRepository {
  constructor(private readonly dataSource: AuthDataSource) {}

  async login(credentials: LoginCredentials): Promise<LoginResult> {
    const { data, access_token } = await this.dataSource.login(credentials);

    return {
      access_token,
      user: {
        id: data.id,
        type: data.type,
      },
    };
  }

  async sendRecoveryEmail(email: string): Promise<{ message: string }> {
    return this.dataSource.sendRecoveryEmail(email);
  }

  async checkSignupActive(): Promise<{ active: boolean }> {
    return this.dataSource.checkSignupActive();
  }
}
